import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import {
  PageContainer,
  HeroImageSection,
  HeroImageWrap,
  HeroImage,
  MainSection,
  PageTitle,
  PageParagraph,
} from '../SimplePage/SimplePageElements';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=900&q=80';

const Investors = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <PageContainer>
        <HeroImageSection>
          <HeroImageWrap>
            <HeroImage src={HERO_IMAGE} alt="Business partnership and growth" />
          </HeroImageWrap>
        </HeroImageSection>
        <MainSection>
          <Link to="/" style={{ color: '#01bf71', fontWeight: 600, textDecoration: 'none', marginBottom: 32, display: 'inline-block' }}>
            ← Back to Home
          </Link>
          <PageTitle>Investors</PageTitle>
          <PageParagraph>
            Wiry is building a strong digital marketing and growth platform for businesses. We help
            brands grow their presence through SEO, social media, and digital solutions—and we’re
            always looking to scale our impact.
          </PageParagraph>
          <PageParagraph>
            If you’re interested in investing in Wiry, we’d like to hear from you. We work with
            investors who share our vision and can help us grow. In return, we focus on sustainable
            growth, clear metrics, and delivering a solid return on investment (ROI) through our
            services and company performance.
          </PageParagraph>
          <PageParagraph>
            Get in touch to learn more about our plans and how we can work together.
          </PageParagraph>
          <PageParagraph>
            <Link to="/contactus" style={{ color: '#01bf71', fontWeight: 600 }}>
              Contact us →
            </Link>
          </PageParagraph>
        </MainSection>
      </PageContainer>
      <Footer />
    </>
  );
};

export default Investors;
